import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { providePrimeNG } from 'primeng/config';
import { NgxPermissionsModule } from 'ngx-permissions';
import { authInterceptorProviders } from './business-domains/retail/shared/billing/src/lib/helper/auth.interceptor';
import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { ElixirBackofficePreset } from './elixir-backoffice-preset';
import { cleanParamsInterceptor } from './core/interceptors/clean-params.interceptor';
import { withInterceptorsFromDi } from '@angular/common/http';
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor, cleanParamsInterceptor]), withInterceptorsFromDi()),
    authInterceptorProviders,
    importProvidersFrom(NgxPermissionsModule.forRoot()),
    providePrimeNG({
      theme: {
        preset: ElixirBackofficePreset,
        options: {
          prefix: 'elixir-backoffice',
          darkModeSelector: '.elixir-backoffice-app-dark'
        }
      }
    }),
  ]
};

